// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../../duck';
import VerificationRemainderModal from '../component/VerificationRemainderModal';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    isResending: state.authModals.isResending,
    resendError: state.authModals.resendError,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(VerificationRemainderModal);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/verification-remainder-modal/container/VerificationRemainderModalContainer.js